import React from 'react';
import Image from 'next/image';
import styles from './CustomLogoHorizontal.module.scss';
import classNames from 'classnames';
import { useCustomOrgContext } from '@/context/customOrgContext';
const CustomLogoHorizontal = () => {
  const {
    CustomOrg
  } = useCustomOrgContext();
  return <>
   <div className={classNames(CustomOrg?.template ? styles['primary-' + CustomOrg?.template] : '', styles['custom-logo'], styles['primary-logo'])} data-bdd={'primary-client-logo'}>
    <Image data-bdd={'bdd-client-logo'} src={CustomOrg?.logo1?.url} alt={'client-logo'} priority={true} width={CustomOrg?.logo1?.width} height={CustomOrg?.logo1?.height} unoptimized={true} data-sentry-element="Image" data-sentry-source-file="CustomLogoHorizontal.tsx" />
   </div>

   <div className={classNames(styles['secondary-client-logos-block'], CustomOrg?.template ? styles[CustomOrg?.template] : '')} data-bdd={'Additional-client-logos'}>
    <div className={classNames(styles['custom-logo'], styles[`clientLogos-2`], styles['secondary-client-logos'], CustomOrg?.template ? styles['secondary-' + CustomOrg?.template] : '', 'd-flex') + ' image-wrapper'} data-bdd={'client-logo-2'} key={`org-xtra-logo2`}>
     <Image data-bdd={'bdd-client-logo'} src={CustomOrg?.logo2?.url} alt={'client-logo'} priority={true} width={CustomOrg?.logo2?.width} height={CustomOrg?.logo2?.height} data-sentry-element="Image" data-sentry-source-file="CustomLogoHorizontal.tsx" />
    </div>
   </div>
  </>;
};
export default CustomLogoHorizontal;